<script lang="ts">
import { REQUEST_STATUS } from '@/app/const';
import { ComplaintInfo } from '@/interface/Complaint.interface';
import { userService } from '@/services/serviceProvider';

export default {
    components: {
    },
    setup() {
        const userSv = userService;
        return { userSv }
    },
    props: {
        modelValue: {
            type: Object,
            default: {},
        },
        viewMode: {
            type: Boolean,
            default: false
        },
    },
    emits: [
        'displayAlertDialog',
    ],
    data() {
        return {
            model: this.modelValue as ComplaintInfo,
            displayComplaintDetail: false,
            panel: [1] as number[],
        }
    },
    watch: {
        modelValue(newVal, oldVal) {
            if (newVal) {
                this.model = newVal;
            }
        },
    },
    computed: {
        isAppeal() {
            return this.model.status === REQUEST_STATUS.APPEAL
        },
    },
    async mounted() {

    },
    methods: {
        openRequest(requestNo: string) {
            const routeData = this.$router.resolve({ path: `/complaint/${requestNo}` });
            window.open(routeData.href, '_blank');
        },
        viewComplaintDetail(detail: string | undefined) {
            if (detail && detail.length > 200) {
                this.displayComplaintDetail = true;
            }
        },
        collapse(value: number) {
            if (this.panel)
                this.panel = this.panel.filter(o => o != value);
        },
        expand(value: number) {
            if (this.panel)
                this.panel.push(value);
        },
    },
};
</script>
<template>
    <v-expansion-panels v-if="!userSv.isAirline() && model.refRequestNo" v-model="panel"
        class="form-card mb-6" multiple>
        <v-expansion-panel :value="1" v-model="panel" multiple>
            <v-expansion-panel-title readonly static>
                <div class="d-flex align-center text-label-large mb-0" style="min-width: fit-content;">
                    <span v-if="isAppeal" class="mr-2">{{ $t('t-action-resend-to') }}</span>
                    <span v-else class="mr-2">{{ $t('t-action-resend-from') }}</span>
                    <v-btn @click="openRequest(model.refRequestNo)" density="compact">
                        <div class="text-primary">
                            <span v-if="model.refComplaintNo">{{ model.refComplaintNo }}</span>
                            <span v-else>{{$t('t-request-no')}}</span>
                        </div>
                    </v-btn>
                </div>
                <template v-slot:actions="{ collapseIcon, expandIcon }">
                    <v-icon v-if="panel.includes(1)" :icon="expandIcon"
                        @click="collapse(1)"></v-icon>
                    <v-icon v-else :icon="collapseIcon"
                        @click="expand(1)"></v-icon>
                </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <v-card-text class="px-6 pt-0 pb-6">
                    <div class="text-label">{{ $t('t-action-resend-reason') }}</div>
                    <v-textarea v-model.trim="model.appealReason" class="hide-float-label" variant="outlined"
                        hide-details="auto" density="comfortable" auto-grow readonly>
                    </v-textarea>
                    <div class="textarea-export formatted-new-line mt-2" style="display: none;">
                        {{ model.appealReason ?? '-' }}
                    </div>
                </v-card-text>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>